import Model from './Model'

export default class Package extends Model {
    static flags() {
        return [
            {label: 'Dead', value: 'dead', icon: 'fas fa-skull', updatable: true},
            {label: 'Archived', value: 'archive', icon: 'fas fa-archive', updatable: true},
            {label: 'Unable To Quote', value: 'unable_to_quote', icon: 'fas fa-ban', updatable: true},
            {label: 'Snagging', value: 'snagging', icon: 'fas fa-exclamation-circle', updatable: false},
            {label: 'On Hold', value: 'hold', icon: 'fas fa-pause-circle', updatable: true},
            {label: 'Inactive', value: 'inactive', icon: 'fas fa-hourglass-end', updatable: false},
            {label: 'Hot Lead', value: 'hot', icon: 'fas fa-fire', updatable: true},
            {label: 'Imminent', value: 'imminent', icon: 'fas fa-bolt', updatable: true},
        ]
    }

    static updatableFlags() {
        return this.flags().filter(flag => flag.updatable)
    }
    setAttributes(attributes) {
        super.setAttributes(attributes);
        this.tokens = attributes.name.split(' ').join('|').toLowerCase();
    }

    static async all(compact = false) {
        const config = compact ? {params: {compacted: true, all: true}} : {all: true}
        const {data} = await Http.get(route('api.v1.packages-dropdown.index'), config)
        return this.make(data)
    }

    static async recent() {
        const {data} = await Http.get(route('api.v1.users.last-packages'))
        return this.make(data)
    }

    static async search(query, compact = false) {
        const params = {search: query}
        if (compact) params.compacted = true
        const {data} = await Http.get(route('api.v1.packages-dropdown.index'), {params})
        return this.make(data)
    }

    static async getStatuses() {
        const {data} = await Http.get(route('api.v1.packages.statuses'))
        return data
    }

    async updateFlags(form) {
        const {data} = await Http.put(route('api.v1.packages.update-flags', this.id), form)
        return this.fill(data)
    }

    async addNote(note) {
        await Http.post(route('api.v1.packages.notes.store', this.id), {note})
    }

    toDropdown() {
        return {label: this.label, value: this.key()}
    }

    async updateStatus(status_id) {
        const {data} = await Http.put(route('api.v1.packages.update-status', this.id), {status_id})
        return this.fill(data)
    }

    async updateLinkedPackages(packages) {
        const {data} = await Http.put(route('api.v1.packages.link', this.id), {packages})
        return this.fill(data)
    }
}
